import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://localhost:7271/api';

export interface TenantConfig {
  tenantSlug: string;
  systemName: string;
  systemNameShort: string;
  logoFilename: string;
  companyNameHebrew: string;
  // שדות חדשים מ-Prompt 2 - נטענים מטבלת SystemParameters per-tenant
  welcomeTitle: string;
  systemTagline: string;
  supportEmail: string;
  supportPhone: string;
  defaultCommissionPercentage: number;
  // האם סליקת אשראי דרך Cardcom מופעלת עבור החברה (קובע הצגת אופציות אשראי ב-UI)
  cardcomEnabled: boolean;
  // האם אופציית הוראת קבע בנקאית מופעלת עבור החברה (תוכנית תשלום ידנית מול הבנק)
  bankStandingOrderEnabled: boolean;
  // האם מודול "ניהול תשלומים" מופעל עבור החברה (קובע הצגת העמוד והתפריט)
  paymentsManagementEnabled: boolean;
}

/**
 * טוען את הגדרות החברה (tenant) מהשרת בזמן עליית האפליקציה.
 * Endpoint חופשי - אין צורך בהתחברות.
 * ערכים שחסרים יחזרו כ-"NOT_FOUND" מהשרת.
 */
export const fetchTenantConfig = async (): Promise<TenantConfig> => {
  const response = await axios.get<TenantConfig>(`${API_BASE_URL}/tenant/config`);
  return response.data;
};
